"use client";

import { LinkHandler } from "@/components/common/LinkHandler";
import MlbTrademark from "@/components/icons/MlbTrademark";
import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

export const mlbBanner = true;

const SHOP_URL = "/hair/men/product/category/";
const HEADLINE = "Step up to the plate for stronger hair.";
const CTA_LABEL = "Shop Now";

type MlbMenNavBannerProps = {
  className?: string;
  layout?: "stacked" | "card";
  onClick?: () => void;
};

const MlbMenNavBanner = ({ className, layout = "stacked", onClick }: MlbMenNavBannerProps) => {
  const isCard = layout === "card";

  return (
    <LinkHandler
      path={SHOP_URL}
      onClick={onClick}
      ariaLabel={`${HEADLINE} ${CTA_LABEL}`}
      className={cn(
        "relative overflow-hidden",
        isCard
          ? "block h-full w-full rounded p-8"
          : "flex min-h-[86px] flex-col rounded-sm md:min-h-[121px]",
        className
      )}
    >
      <Picture
        src={
          isCard
            ? "https://images.ctfassets.net/0rbfqd9c4jdo/3ZaIEWJExjiDazw9iqEk4Q/2e9fa3337c15c6503139606802fbdce0/mlb-nav-banner-desktop.jpg"
            : "https://images.ctfassets.net/0rbfqd9c4jdo/3IEV9a90Uc2Whd7U9Ea4K2/922c1e19a1470ea9b1719d021e4f1a0e/mlb-nav-banner-mobile.jpg"
        }
        sources={
          isCard
            ? []
            : [
                {
                  media: "(min-width: 768px)",
                  srcSet:
                    "https://images.ctfassets.net/0rbfqd9c4jdo/1xlV6qhc8gPq7vngBY4k8A/22ac9bca89daab08eb5d0afaef7b6207/mlb-nav-banner-tablet.jpg",
                },
              ]
        }
        alt=""
        role="presentation"
        pictureClassName="pointer-events-none absolute inset-0 h-full w-full"
        className="h-full w-full object-cover"
      />
      <div
        className={cn(
          "relative flex w-full flex-col items-center",
          isCard ? "h-full justify-between" : "min-h-full flex-1 justify-center gap-2 px-6 py-4"
        )}
      >
        <TextElementNova
          text={HEADLINE}
          className="Body-30-Dia-Strong text-center text-nova-base-white"
        />
        <ButtonNova
          label={CTA_LABEL}
          icon="Right"
          level="Tertiary"
          copyClassName="text-nova-base-white"
          tabIndex={-1}
          aria-hidden
          className="pointer-events-none"
        />
      </div>
      <MlbTrademark
        className={cn(
          "pointer-events-none absolute bottom-2 right-2 h-[6px] w-[49px]",
          !isCard && "w-[50px] md:h-2 md:w-[65px]"
        )}
      />
    </LinkHandler>
  );
};

export default MlbMenNavBanner;
